import { render, staticRenderFns } from "./FilterBox.vue?vue&type=template&id=545eac7a&scoped=true"
import script from "./FilterBox.vue?vue&type=script&lang=js"
export * from "./FilterBox.vue?vue&type=script&lang=js"
import style0 from "./FilterBox.vue?vue&type=style&index=0&id=545eac7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545eac7a",
  null
  
)

export default component.exports